import { render, staticRenderFns } from "./HelpMenu.vue?vue&type=template&id=b22aeeb8&scoped=true&"
import script from "./HelpMenu.vue?vue&type=script&lang=js&"
export * from "./HelpMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22aeeb8",
  null
  
)

export default component.exports